<template>
<div class="chapter">
<div class="inner_page">
<h1 class="hide">Copyright</h1>
<p class="Basic-Paragraph para-style-override-8">Copyright © 2016 </p>
<p class="Basic-Paragraph"><span class="char-style-override-6">By C</span><span class="char-style-override-7">apt </span><span class="char-style-override-6">Robert Mueller, U.S. Coast Guard (ret)</span></p>
<hr/>
<p class="Basic-Paragraph para-style-override-2"><span class="italics char-style-override-8">The word “Pelican” and the depiction of a pelican are <br/>trademarks of Pelican Publishing Company, Inc. and are <br/>registered in the U.S. Patent and Trademark Office.</span><span class="char-style-override-6"></span></p>
<hr/>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8">ISBN: 9781455622207</p>
<p class="Basic-Paragraph para-style-override-8">E-book ISBN: 9781455622214</p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-8"></p>
<div class="frame-2">
<img alt="28705.jpg" class="frame-4" src="Images/28705.jpg"/>
</div>
<p class="Basic-Paragraph para-style-override-8"></p>
<p class="Basic-Paragraph para-style-override-10">Printed in the United States of America</p>
<p class="Basic-Paragraph para-style-override-8">Published by Pelican Publishing Company, Inc.</p>
<p class="Basic-Paragraph para-style-override-11"><span class="char-style-override-6">1000 Burmaster Street, Gretna, Louisiana 70053</span><span class="char-style-override-9"></span></p>
<p class="x-1-chapter-number"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?447ff724